import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import { createLogger } from "redux-logger";

import rootReducer from "./rootReducer";

export const history = createBrowserHistory();

let store;

export default function configureAppStore() {
  const middleware = [...getDefaultMiddleware(), routerMiddleware(history)];

  if (process.env.NODE_ENV === "development") {
    middleware.push(createLogger());
  }

  store = configureStore({
    reducer: rootReducer(history),
    middleware,
    // preloadedState,
  });
  return store;
}

export function getStore(){
  if (store !== undefined){
    return store;
  }
  throw new Error("store not initialized with configureAppStore");
}

export type RootState = ReturnType<ReturnType<typeof rootReducer>>;
export type AppDispatch = ReturnType<typeof configureAppStore>["dispatch"];